import React, { useState } from 'react';
import PhotoSelection from './photo-selection';
import { useGetUser } from '../../hooks/api-hooks';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import PhotoGuidelinesCreateNeofaceModal from './photo-guidelines-create-neoface-modal';

interface PhotoSelectionStepProps {
  onDone: () => void;
}

const PhotoSelectionStep: React.FC<PhotoSelectionStepProps> = ({ onDone }) => {
  const [showGuidelinesModal, setShowGuidelinesModal] = useState(false);
  const user = useGetUser();

  return (
    <div className="flex flex-col h-full">
      {/* Header section */}
      <div className="mb-2">
        <h2 className="text-xl font-semibold mb-2">Step 1: Take a Picture</h2>
        {/*rounded bg-indigo-50 px-2 py-1 text-xs font-semibold text-indigo-600 shadow-sm hover:bg-indigo-100*/}
        {/* Enhanced Photo Guidelines Button */}
        <button
          onClick={() => setShowGuidelinesModal(true)}
          className="inline-flex items-center px-3 py-1.5 rounded-md bg-indigo-50 text-indigo-600 hover:bg-indigo-100 transition-colors font-medium text-sm border shadow-sm border-indigo-200"
        >
          <InformationCircleIcon className="h-5 w-5 mr-1.5" />
          Photo Guidelines
        </button>
      </div>

      {showGuidelinesModal && (
        <PhotoGuidelinesCreateNeofaceModal
          isOpen={showGuidelinesModal}
          onClose={() => setShowGuidelinesModal(false)}
        />
      )}

      <p className="text-gray-600 mb-4">
        We'll create anonymous versions of you to choose from. Ensure your face is well-lit and centered in the frame.
      </p>

      <PhotoSelection
        hasPersona={!!user.data?.persona.id}
        onGeneratePersonasDone={() => onDone()}
      />
    </div>
  );
};

export default PhotoSelectionStep;